<template>
  <div>
    <base-header class="header pb-5 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white">
              Aqui você pode realizar sua inscrição na chamada para startups
              Stars. Enquanto a chamada permancer com as inscrições abertas,
              você poderá revisar e atualizar as informações submetidas a
              qualquer momento.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <form-wizard
            ref="wizard"
            color="#ff4200"
            @on-change="updateCurrentStep"
          >
            <template slot="title">
              <div class="col-12"></div>
              <div class="mt-4">
                <progress-bar
                  :step="Math.max(currentStep - 1, 1)"
                  :total-steps="7"
                />
              </div>
            </template>

            <!-- Programa -->
            <tab-content title="Programa" icon="ni ni-single-02">
              <div
                class="card card-profile shadow vld-parent"
                ref="form_edit_container"
              >
                <div class="text-center mt-4">
                  <h2 class="text-danger mb-2">
                    {{ call.name || "Chamada para Startups" }}
                  </h2>
                  <h3 class="value-text">Stars Aceleradora</h3>
                  <!--
                  <h4 class="mt-3">
                    <strong>Região:</strong> {{ call.region }}
                  </h4>
                  -->
                  <p class="mt-2">
                    <strong>Chamada aberta de:</strong>
                    {{ formatDate(call.start_date, "L") }} até
                    {{ formatDate(call.end_date, "L") }}
                  </p>
                </div>

                <div class="row justify-content-center my-4">
                  <div class="col-md-3 col-sm-6 mb-3">
                    <div class="value-box text-center p-4">
                      <i class="fas fa-dollar-sign icon mb-2"></i>
                      <h4 class="value-text">
                        {{ formatValue(call.max_value) || "R$ -" }}
                      </h4>
                      <p class="value-label">INVESTIMENTO MÁXIMO</p>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 mb-3">
                    <div class="value-box text-center p-4">
                      <i class="fas fa-percentage icon mb-2"></i>
                      <h4 class="value-text">
                        {{ call.max_equity + " %" || "0%" }}
                      </h4>
                      <p class="value-label">PERCENTUAL MÁXIMO</p>
                    </div>
                  </div>

                  <div class="col-md-3 col-sm-6 mb-3">
                    <div class="value-box text-center p-4">
                      <i class="fas fa-rocket icon mb-2"></i>
                      <h4 class="value-text">
                        {{ call.max_startups || "N/A" }}
                      </h4>
                      <p class="value-label">NÚMERO DE STARTUPS</p>
                    </div>
                  </div>
                </div>

                <!-- Descrição -->
                <div class="text-center px-4">
                  <p class="text-muted">
                    Estamos em busca de startups inovadoras e em estágio inicial
                    que demonstrem potencial de crescimento e tenham ambição de
                    impactar seus respectivos setores. Se você está buscando
                    orientação especializada, acesso a recursos e uma rede de
                    contatos sólida, esta é a sua oportunidade de acelerar o
                    crescimento da sua startup.
                  </p>
                </div>

                <div class="text-center my-3">
                  <a
                    class="btn btn-outline-danger"
                    href="https://portalstars-editais.s3.us-east-1.amazonaws.com/edital_batch_2025.pdf"
                    target="_blank"
                  >
                    <i class="fas fa-file-alt mr-2"></i>
                    Edital Batch 2025
                  </a>
                </div>
                <hr />
                <div class="text-center mb-3">
                  <p class="text-danger font-weight-bold">
                    O formulário é composto por 6 etapas <br />
                    Tempo médio para preenchimento: 20min
                  </p>
                </div>
                <div class="text-center text-muted small px-4 mb-4">
                  <i class="fas fa-info-circle mr-1"></i>
                  Os dados informados na inscrição serão analisados pela Stars e
                  utilizados como critérios de seleção para nosso Programa de
                  Aceleração. Ao continuar, você concorda com o uso das
                  informações preenchidas para fins do processo seletivo do
                  {{ call.name }}. Mais detalhes podem ser encontrados em nosso
                  <a
                    href="https://starsaceleradora.com.br/aceleracao-stars/"
                    target="_blank"
                    >website</a
                  >.
                </div>
              </div>
            </tab-content>

            <!-- Cadastro -->
            <tab-content title="Cadastro" icon="ni ni-collection">
              <div
                class="card card-profile shadow vld-parent"
                ref="form_edit_container"
              >
                <div class="card-body mt-2 pt-0 pt-md-4">
                  <div class="row ml-2">
                    <div class="orange-title">Etapa 1: Cadastro</div>
                  </div>
                  <div class="row ml-2">
                    <h6 class="heading-small text-muted mb-4">
                      Informações básicas para identificação da startup e
                      responsável.
                    </h6>
                  </div>

                  <div class="ml-2">
                    <base-input
                      label="Nome da startup"
                      v-model="model.startup.name"
                      placeholder="Digite o nome da startup"
                      disabled
                    />
                    <base-input
                      label="Data de fundação da startup"
                      type="date"
                      v-model="model.startup.foundation"
                      required
                    />
                    <estados
                      estadoLabel="Estado da startup"
                      cidadeLabel="Cidade da startup"
                      :selectedEstado="model.startup.state"
                      :selectedCidade="model.startup.city"
                      @inputEstado="model.startup.state = $event"
                      @inputCidade="model.startup.city = $event"
                    />
                  </div>
                  <div class="row ml-2 section-divider">
                    <h6 class="heading-small text-muted mb-4">
                      Informações do responsável
                    </h6>
                  </div>
                  <div class="ml-2">
                    <base-input
                      label="Nome completo"
                      v-model="model.responsible.responsible_name"
                      placeholder="Digite o nome completo do responsável"
                      :disabled="responsibleFieldsLocked.responsible_name"
                    />

                    <base-input
                      label="Celular ou telefone (com DDD)"
                      v-model="model.responsible.responsible_phone"
                      placeholder="(99) 99999-9999"
                      v-mask="'(##) #####-####'"
                      :disabled="responsibleFieldsLocked.responsible_phone"
                    />

                    <base-input
                      label="E-mail"
                      v-model="model.responsible.responsible_email"
                      placeholder="exemplo@minhastartup.com"
                      :disabled="responsibleFieldsLocked.responsible_email"
                    />

                    <base-input
                      label="Website da startup (opcional)"
                      v-model="model.startup.product_more_information.link"
                      placeholder="Digite o melhor Website da sua startup"
                    />
                  </div>
                </div>
                <div class="text-center mt-4" v-if="errors.stepError.show">
                  <base-alert type="default">{{
                    errors.stepError.text
                  }}</base-alert>
                </div>
              </div>
            </tab-content>
            <!-- Negócio -->
            <tab-content
              title="Negócio"
              icon="ni ni-building"
              :before-change="
                () => validateStep(2, this.modelForStep('business'))
              "
            >
              <div class="card card-profile shadow">
                <div class="card-body mt-2 pt-0 pt-md-4">
                  <div class="row ml-2">
                    <div class="orange-title">Etapa 2: Negócio</div>
                  </div>
                  <div class="row ml-2">
                    <h6 class="heading-small text-muted mb-4">
                      Descreva a essência da startup e seu funcionamento.
                    </h6>
                  </div>
                  <div class="ml-2">
                    <div class="col-lg-6">
                      <base-input
                        label="Definição sucinta do seu negócio em uma única frase (one-line pitch)"
                        required
                      >
                        <textarea
                          placeholder="Brevemente, qual é a definição do seu negócio?"
                          rows="1"
                          v-model="model.product.one_sentence_pitch"
                          class="form-control form-control"
                          style="white-space: pre-line"
                        >
                        </textarea>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Qual é o problema ou necessidade específica dos clientes que sua empresa busca resolver?"
                        required
                      >
                        <textarea
                          rows="1"
                          v-model="model.product.product_market_problem"
                          class="form-control form-control"
                          placeholder="Brevemente, qual o principal problema ou necessidade de clientes seu produto ou serviço resolve?"
                          style="white-space: pre-line"
                        >
                        </textarea>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Qual o modelo de negócios de sua startup?"
                        required
                      >
                        <select
                          class="form-control"
                          v-model="model.product.bussiness_strategy"
                        >
                          <option value="" selected disabled>
                            Selecione uma opção
                          </option>
                          <option
                            v-for="option in bussinesModels"
                            :key="option"
                            :value="option"
                          >
                            {{ option }}
                          </option>
                        </select>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Em qual(is) setor(es) econômico(s) sua startup atua? Você pode informar mais de uma opção."
                        required
                      >
                        <v-select
                          :components="{ OpenIndicator }"
                          class="sector_select"
                          multiple
                          placeholder="Selecione um ou mais setores"
                          label="name"
                          :options="economicSectors"
                          v-model="model.product.sector"
                          :closeOnSelect="false"
                        />
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Em qual mercado principal sua startup pretende atuar?"
                        required
                      >
                        <select
                          class="form-control"
                          v-model="model.startup.bussiness_strategy"
                        >
                          <option value="" selected disabled>
                            Selecione uma opção
                          </option>
                          <option
                            v-for="(option, index) in mainMarkets"
                            :key="index"
                            :value="option"
                          >
                            {{ option }}
                          </option>
                        </select>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group has-label">
                        <base-input
                          label="Qual o estágio da sua startup?"
                          required
                        >
                          <select
                            class="form-control"
                            v-model="model.product.stage"
                          >
                            <option value="" selected disabled>
                              Selecione uma opção
                            </option>
                            <option
                              v-for="stage in Object.keys(stages)"
                              :key="'stage_' + stage"
                              :value="stage"
                            >
                              {{ stages[stage] }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <base-input
                        label="Quais são os desafios mais significativos que sua empresa enfrenta atualmente?"
                        required
                      >
                        <textarea
                          rows="2"
                          v-model="model.product.startup_problem"
                          class="form-control"
                          placeholder="Digite aqui..."
                        >
                        </textarea>
                      </base-input>
                    </div>
                    <div class="col-lg-12 mt-4">
                      <base-input
                        label="De que forma você espera que a Stars possa auxiliar a sua startup?"
                        required
                      >
                        <textarea
                          rows="2"
                          v-model="model.product.how_can_stars_help"
                          class="form-control"
                          placeholder="Digite aqui."
                        >
                        </textarea>
                      </base-input>
                    </div>
                  </div>
                  <div class="text-center mt-4" v-if="errors.stepError.show">
                    <base-alert type="default">{{
                      errors.stepError.text
                    }}</base-alert>
                  </div>
                </div>
              </div>
            </tab-content>
            <!-- Mercado -->
            <tab-content title="Mercado" icon="ni ni-chart-bar-32">
              <div
                class="card card-profile shadow vld-parent"
                ref="form_edit_container"
              >
                <div class="card-body mt-2 pt-0 pt-md-4">
                  <div class="row ml-2">
                    <div class="orange-title">Etapa 3: Mercado</div>
                  </div>
                  <div class="row ml-2">
                    <h6 class="heading-small text-muted mb-4">
                      Informações sobre o mercado e performance recente.
                    </h6>
                  </div>
                  <div class="ml-2">
                    <base-input
                      label="Qual foi o valor total do faturamento no último trimestre em reais?"
                      type="text"
                      :value="
                        formatCurrency(model.product.last_quarters_revenue)
                      "
                      placeholder="Digite o faturamento dos últimos 3 meses"
                      @input="onLastQuartersRevenueInput($event)"
                      maxlength="20"
                      required
                    />

                    <base-input
                      label="Qual o tamanho de mercado em reais?"
                      type="text"
                      :value="formatCurrency(model.product.market_size)"
                      placeholder="Número de tamanho de mercado"
                      @input="onMarketSizeInput($event)"
                      maxlength="20"
                      required
                    />
                    <base-input
                      label="Quantos clientes ativos a startup possui atualmente?"
                      type="number"
                      step="1"
                      placeholder="Digite o número de clientes ativos"
                      v-model="model.product.active_customers"
                      v-on:keypress="isNumber($event)"
                      required
                    />
                    <base-input
                      label="Qual a maior vantagem competitiva da sua startup frente às soluções existentes no mercado atual?"
                      required
                    >
                      <textarea
                        rows="2"
                        v-model="model.product.product_competitive_advantage"
                        class="form-control form-control"
                        placeholder="E.g. pioneirismo, conhecimento especializado, tecnologia proprietária, patentes, ..."
                      >
                      </textarea>
                    </base-input>
                  </div>
                </div>
                <div class="text-center mt-4" v-if="errors.stepError.show">
                  <base-alert type="default">{{
                    errors.stepError.text
                  }}</base-alert>
                </div>
              </div>
            </tab-content>
            <!-- Time -->
            <tab-content title="Time" icon="fa fa-users">
              <div
                class="card card-profile shadow vld-parent"
                ref="form_edit_container"
              >
                <div class="card-body mt-2 pt-0 pt-md-4">
                  <div class="row ml-2">
                    <div class="orange-title">Etapa 4: Time</div>
                  </div>
                  <div class="row ml-2">
                    <h6 class="heading-small text-muted mb-4">
                      Composição societária e envolvimento dos sócios.
                    </h6>
                  </div>
                  <div class="col-lg-12">
                    <label for="" class="form-control-label"
                      >Como está o captable atual?</label
                    >
                    <p class="description mt--1">
                      Se houver sócios investidores, incluí-los também
                    </p>
                  </div>

                  <div
                    v-for="(partner, index) in model.partners"
                    :key="index"
                    class="ml-2 mb-4"
                  >
                    <label class="form-control-label"
                      >Sócio {{ index + 1 }}</label
                    >

                    <base-input
                      label="Nome completo"
                      v-model="partner.name"
                      placeholder="Digite o nome completo do sócio"
                      required
                    />

                    <base-input
                      label="Dedicação (integral/parcial)"
                      v-model="partner.dedication"
                      placeholder="Escreva a dedicação do sócio"
                      required
                    />

                    <base-input
                      label="Percentual da sociedade"
                      :value="formatPercentage(partner.percentage)"
                      placeholder="Ex: 15%"
                      type="text"
                      @input="onPartnerPercentageInput($event, partner)"
                      maxlength="4"
                      required
                    />

                    <base-input
                      label="Função na Startup"
                      v-model="partner.role"
                      placeholder="Insira a função do sócio na startup"
                      required
                    />

                    <base-input
                      label="LinkedIn (opcional)"
                      v-model="partner.linkedin"
                      placeholder="Insira o link do LinkedIn do sócio"
                    />

                    <button
                      class="btn btn-sm btn-outline-danger mt-2"
                      v-if="model.partners.length > 1"
                      @click.prevent="model.partners.splice(index, 1)"
                    >
                      Remover Sócio
                    </button>
                  </div>

                  <button
                    class="btn btn-primary wizard-footer-right orange-button"
                    @click.prevent="addPartner"
                    v-tooltip="'Adicionar sócio'"
                  >
                    <i class="fas fa-plus mr-2"></i> Adicionar outro sócio
                  </button>

                  <div class="section-divider mt-4 mb-2"></div>
                  <base-input
                    label="A startup já participou da seleção em outro Batch da Stars? Caso sim, quando?"
                    required
                  >
                    <div class="ml-2">
                      <textarea
                        rows="2"
                        v-model="model.startup.already_participated_batch"
                        class="form-control"
                        placeholder="Digite aqui."
                      >
                      </textarea>
                    </div>
                  </base-input>
                </div>
                <div class="text-center mt-4" v-if="errors.stepError.show">
                  <base-alert type="default">{{
                    errors.stepError.text
                  }}</base-alert>
                </div>
              </div>
            </tab-content>

            <!-- Proposta -->
            <tab-content title="Proposta" icon="ni ni-money-coins">
              <div
                class="card card-profile shadow vld-parent"
                ref="form_edit_container"
              >
                <div class="card-body mt-2 pt-0 pt-md-4">
                  <div class="row ml-2">
                    <div class="orange-title">Etapa 5: Proposta</div>
                  </div>
                  <div class="row ml-2">
                    <h6 class="heading-small text-muted mb-4">
                      O que a startup busca no momento.
                    </h6>
                  </div>

                  <div class="ml-2">
                    <base-input
                      label="Qual o valor de investimento que a startup busca?"
                      :value="formatCurrency(model.proposal.investment_sought)"
                      placeholder="Ex: 500000"
                      type="text"
                      @input="onInvestmentSoughtInput($event)"
                      maxlength="20"
                      required
                    />
                    <base-input
                      label="Qual o percentual de equity oferecido?"
                      :value="formatPercentage(model.proposal.equity_offered)"
                      placeholder="Ex: 15%"
                      type="text"
                      @input="onEquityOfferedInput($event)"
                      maxlength="6"
                      required
                    />
                  </div>
                </div>
                <div class="text-center mt-4" v-if="errors.stepError.show">
                  <base-alert type="default">{{
                    errors.stepError.text
                  }}</base-alert>
                </div>
              </div>
            </tab-content>

            <!-- Pitch -->
            <tab-content title="Pitch" icon="fa fa-desktop">
              <div
                class="card card-profile shadow vld-parent"
                ref="form_edit_container"
              >
                <div class="card-body mt-2 pt-0 pt-md-4">
                  <div class="row ml-2">
                    <div class="orange-title">Etapa 6: Pitch</div>
                  </div>

                  <div class="row ml-2">
                    <h6 class="heading-small text-muted mb-4">
                      Material complementar para análise.
                    </h6>
                  </div>

                  <div class="ml-2 mb-4">
                    <base-input label="Pitch Deck" required>
                      <p class="form-text mb-2">
                        📄 Deve ser uma apresentação em
                        <strong>formato PDF</strong>. O arquivo deve ter um
                        <strong>tamanho máximo de 15mb</strong>.
                      </p>
                      <div class="col-12">
                        <file-select
                          v-model="model.presentation.pitch_deck"
                          :key="fileInputKey"
                          title="Selecione o pitch deck"
                          placeholder="Selecione o arquivo..."
                          accept="application/pdf"
                          :mbSize="15"
                          class="orange-button-pitch"
                        />
                        <div
                          v-if="model.presentation.pitch_deck"
                          class="text-sm text-muted d-inline-block"
                        >
                          <span class="text-sm text-muted mr-2">
                            <button
                              type="button"
                              class="btn btn-link text-danger p-0 ml-2"
                              @click="removePitchDeck"
                              title="Remover arquivo"
                            >
                              <i class="fas fa-times"></i>
                              remover
                            </button>
                          </span>
                          <span class="text-sm text-muted">
                            |
                            <i class="fas fa-info-circle"></i>
                            Arquivo selecionado. Tamanho:
                            {{ getMbSize(model.presentation.pitch_deck.size) }}
                          </span>
                        </div>
                        <p
                          class="text-sm text-muted d-inline-block mx-3"
                          v-if="!model.presentation.pitch_deck"
                        >
                          <i class="fas fa-info-circle mr-1"></i>
                          Deve possuir tamanho máximo de <b>15MB</b>.
                        </p>
                      </div>
                      <p class="text-sm text-warning mt-2">
                        <i class="fas fa-info-circle mr-1"></i>Após concluir a
                        inscrição, o documento enviado
                        <strong>poderá ser alterado</strong> a qualquer momento
                        antes do encerramento das inscrições.
                      </p>
                    </base-input>
                    <p class="mt-2">
                      <strong>Dica:</strong> Confirme se seu pitch deck responde
                      às seguintes perguntas:
                    </p>
                    <ul style="font-size: 13px; padding-left: 1rem">
                      <li>Qual o problema de mercado?</li>
                      <li>
                        Como essa dor é endereçada hoje? (ex: concorrentes
                        diretos e indiretos)
                      </li>
                      <li>
                        Como sua startup resolve o problema? (reforce os
                        diferenciais competitivos)
                      </li>
                      <li>Qual o tamanho de mercado?</li>
                      <li>Quem é o time fundador?</li>
                      <li>
                        Quanto busca de investimento por quanto de equity?
                      </li>
                    </ul>
                  </div>
                  <hr />
                  <div class="ml-2 mb-4">
                    <base-input label="Pitch Vídeo (Opcional)">
                      <p class="form-text text-muted">
                        🎥 Deve ser um vídeo no <strong>YouTube</strong> (com
                        compartilhamento de link e preferencialmente não
                        listado) de até <strong>3 minutos de duração</strong>,
                        gravado na horizontal. Vídeos acima dessa duração não
                        serão considerados.
                      </p>
                      <p class="form-text text-muted mt-2">
                        Este vídeo poderá ser usado para melhor compreensão do
                        negócio da startup.
                      </p>
                      <base-input
                        label="Cole aqui o link do vídeo no YouTube"
                        v-model="model.presentation.pitch_video_url"
                        placeholder="https://youtube.com/..."
                      />
                    </base-input>
                  </div>
                </div>

                <div class="text-center mt-4" v-if="errors.stepError.show">
                  <base-alert type="default">{{
                    errors.stepError.text
                  }}</base-alert>
                </div>
              </div>
              <div class="card card-profile shadow vld-parent mt-4">
                <div class="card-body pt-3 pb-3 px-4">
                  <div class="d-flex align-items-start">
                    <i class="fas fa-info-circle text-muted mr-2 mt-1"></i>
                    <p class="text-muted small mb-0">
                      Os dados informados na inscrição serão analisados pela
                      Stars e utilizados como critérios de seleção para nosso
                      Programa de Aceleração. Ao continuar, você concorda com o
                      uso das informações preenchidas para fins do processo
                      seletivo do <strong>{{ call.name }}</strong
                      >. Mais detalhes podem ser encontrados em nosso website.
                    </p>
                  </div>
                </div>
              </div>
            </tab-content>

            <template slot="footer" slot-scope="props">
              <div class="wizard-footer-left">
                <wizard-button
                  v-if="props.activeTabIndex > 0"
                  @click.native="
                    handleStepBack(props.activeTabIndex, props.prevTab)
                  "
                  :style="props.fillButtonStyle"
                  ><i class="fas fa-chevron-left mr-2"></i>
                  Voltar</wizard-button
                >
              </div>
              <div class="wizard-footer-right">
                <wizard-button
                  v-if="!props.isLastStep"
                  @click.native="
                    handleStepAdvance(props.activeTabIndex, props.nextTab)
                  "
                  class="wizard-footer-right"
                  :style="props.fillButtonStyle"
                >
                  Avançar <i class="fas fa-arrow-right mr-2"></i>
                </wizard-button>

                <wizard-button
                  v-else
                  @click.native="onComplete()"
                  class="wizard-footer-right finish-button"
                  :style="props.fillButtonStyle"
                  :disabled="!model.presentation.pitch_deck"
                  >Concluir inscrição <i class="fas fa-check-circle ml-1"></i
                ></wizard-button>
              </div>
            </template>
          </form-wizard>

          <modal
            :show.sync="modals.confirmation"
            gradient="warning"
            modal-classes="modal-danger modal-dialog-centered"
          >
            <h6 slot="header" class="modal-title" id="modal-title-notification">
              Atenção!
            </h6>
            <div class="vld-parent" ref="modal_confirmation">
              <div class="py-3 text-center">
                <i class="fa fa-plane fa-3x"></i>
                <h4 class="heading mt-4">Quase lá!</h4>
                <p class="mt-3">
                  Você realmente deseja concluir sua inscrição na chamada
                  <span class="font-weight-bold">{{ call.name }}</span
                  >?
                </p>
                <p class="text-sm">
                  <i class="fas fa-info-circle mr-1"></i> Lembre-se, se
                  necessário, você poderá atualizar sua submissão enquanto a
                  chamada permanecer aceitando respostas.
                </p>
              </div>
            </div>
            <template slot="footer">
              <base-button
                type="link"
                text-color="white"
                class="ml-auto"
                @click="modals.confirmation = false"
              >
                Voltar
              </base-button>
              <base-button
                type="white"
                @click="handleSubmit"
                :disabled="modals.disabledSubmit"
              >
                Confirmar inscrição
              </base-button>
            </template>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-select/dist/vue-select.css";

import { getIdFromUrl } from "vue-youtube";
import ProgressBar from "@/components/ProgressBar.vue";
import vSelect from "vue-select";
import { gtmEvent } from "@/utils/gtm";

import api from "@/services/api.js";

export default {
  name: "inscricao",
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    "v-select": vSelect,

    ProgressBar,
  },
  data() {
    return {
      call: {
        description: "",
        end_date: "",
        max_equity: "",
        max_startups: "",
        max_value: "",
        name: "",
        observation: "",
        region: "",
        region_limited: "",
        sectors: "",
        start_date: "",
        type: "",
      },
      startup: {
        city: "",
        state: "",
        foundation: "",
        how_meet_stars: "",
        name: "",
        one_sentence_pitch: "",
        sector: "",
        stage: "",
        logo: "",
      },
      bgClasses: [
        "warning",
        "info",
        "primary",
        "success",
        "secondary",
        "danger",
        "light",
        "dark",
      ],
      economicSectors: [
        "Aeroespacial",
        "Agricultura",
        "Alimentos e bebidas",
        "Biotecnologia",
        "Computadores e periféricos",
        "Construção",
        "Consultoria",
        "Dispositivos e equipamentos médicos",
        "Educação",
        "Eletrônica/instrumentação",
        "Esportes",
        "Estilo de vida",
        "Imóveis",
        "Indústria/energia",
        "Internet/serviços da web",
        "Jogos",
        "Jurídico",
        "Marketing digital",
        "Marketing/publicidade",
        "Marítimo",
        "Mineração",
        "Moda",
        "Mídias e entretenimento",
        "Nanotecnologia",
        "Náutica/Navegação",
        "Petróleo e gás",
        "Produtos da empresa",
        "Produtos de consumo",
        "Redes e equipamentos",
        "Robótica",
        "Segurança",
        "Semicondutores",
        "Serviços a empresas",
        "Serviços ao consumidor",
        "Serviços de saúde",
        "Serviços de TI",
        "Serviços financeiros",
        "Serviços móveis",
        "Software",
        "Substâncias e produtos químicos",
        "Tecnologia limpa",
        "Tecnologia para finanças",
        "Telecomunicações",
        "Transportes",
        "Turismo",
        "Varejo/distribuição",
        "Outro",
      ],
      stages: {
        concept: "Ideação",
        validation: "Validação",
        traction: "Tração",
        scale: "Escala",
        other: "Outro",
      },
      bussinesModels: [
        "E-commerce",
        "Marketplace (take rate)",
        "PPU (Pay per use)",
        "SaaS (Software as a Service)",
        "% sobre ganho do cliente (Success Fee)",
        "Com base em audiência/propaganda (Audience/Ads based)",
        "Outros",
      ],
      mainMarkets: [
        "Business to Business (B2B)",
        "Business to Consumer (B2C)",
        "Business to Business + Business to Consumer (B2B+B2C)",
        "Business to Government (B2G)",
        "Consumer to Consumer (C2C)",
        "Outros",
      ],

      model: {
        startup_id: null,
        userAgreement: true,
        presentation: {
          pitch_video_url: "",
          pitch_youtube_video_id: "",
          pitch_deck: null,
        },
        startup: {
          name: "",
          foundation: "",
          state: "",
          city: "",
          bussiness_strategy: "",
          product_more_information: { link: "" },
        },
        proposal: {
          investment_sought: 0,
          equity_offered: null,
        },
        partners: [
          {
            name: "",
            dedication: "",
            percentage: "",
            role: "",
            linkedin: "",
          },
        ],
        responsible: {
          responsible_name: "",
          responsible_phone: "",
          responsible_email: "",
        },
        product: {
          one_sentence_pitch: "",
          product_market_problem: "",
          bussiness_strategy: "",
          sector: "",
          stage: "",
          startup_problem: "",
          how_can_stars_help: "",
          market_size: 0,
          last_quarters_revenue: 0,
          active_customers: 0,
        },
      },
      fileInputKey: 0,
      errors: {
        stepError: {
          show: false,
          text: "Preencha todos os campos obrigatórios antes de continuar.",
        },
        submitError: {
          show: false,
          text: "Ocorreu um erro ao realizar a inscrição. Tente novamente.",
        },
      },
      modals: {
        confirmation: false,
        disabledSubmit: false,
      },
      OpenIndicator: {
        render: (createElement) =>
          createElement("i", { class: { "toggle fas fa-search": true } }),
      },
      currentStep: 1,
      responsibleFieldsLocked: {
        responsible_name: false,
        responsible_phone: false,
        responsible_email: false,
      },
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.form_edit_container,
      width: 140,
      height: 140,
      opacity: 1,
    });
    try {
      const { data } = await api.get(`/startup-calls/${this.$route.params.id}`);
      if (data.sectors) data.sectors = data.sectors.split(";").filter((s) => s);
      Object.assign(this.call, data);
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      this.$router.push("/startup/chamadas");
    }
    try {
      const { data } = await api.get(`/startups`);
      this.startup = data;
      if (data.foundation && !this.model.startup.foundation) {
        this.model.startup.foundation = data.foundation;
      }
      if (data.state && !this.model.startup.state) {
        this.model.startup.state = data.state;
      }
      if (data.city && !this.model.startup.city) {
        this.model.startup.city = data.city;
      }
      if (data.stage && !this.model.product.stage) {
        this.model.product.stage = data.stage;
      }
      if (data.sector && !this.model.product.sector) {
        this.model.product.sector = data.sector.split(";").filter((s) => s);
      }
      if (data.one_sentence_pitch && !this.model.product.one_sentence_pitch) {
        this.model.product.one_sentence_pitch = data.one_sentence_pitch;
      }
      if (data.bussiness_strategy && !this.model.product.bussiness_strategy) {
        this.model.product.bussiness_strategy = data.bussiness_strategy;
      }
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      this.$router.push("/startup");
    }

    try {
      const { data } = await api.get("/partial/startups/");
      if (data) {
        this.model.startup_id = data.user_id;
        this.model.startup.name = data.name || "";
      } else {
        this.model.startup_id = null;
      }
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os dados parciais");
    }

    try {
      const { data } = await api.get(
        "/partial/startup-call-subscriptions/" + this.model.startup_id
      );
      if (data) {
        if (data.subscription.responsible_name) {
          this.model.responsible.responsible_name =
            data.subscription.responsible_name;
          this.responsibleFieldsLocked.responsible_name = true;
        }
        if (data.subscription.responsible_phone) {
          this.model.responsible.responsible_phone =
            data.subscription.responsible_phone;
          this.responsibleFieldsLocked.responsible_phone = true;
        }
        if (data.subscription.responsible_email) {
          this.model.responsible.responsible_email =
            data.subscription.responsible_email;
          this.responsibleFieldsLocked.responsible_email = true;
        }
      }
    } catch {
      if (this.currentStep !== 1) {
        this.$toasted.error(
          "Não foi possível recuperar os dados da inscrição parcial."
        );
      }
    }

    await this.loadExistingSubscription();
    await this.loadUserProgress();

    loader.hide();
  },
  methods: {
    onCurrencyInput(e, modelPath) {
      let val = e && e.target ? e.target.value : e;
      const onlyNumbers = val.replace(/\D/g, "");

      this.setNestedProperty(modelPath, onlyNumbers ? Number(onlyNumbers) : 0);

      if (e && e.target) {
        const formatted = this.formatCurrency(onlyNumbers);
        this.updateInputWithCursor(e.target, formatted);
      }
    },

    onInvestmentSoughtInput(e) {
      this.onCurrencyInput(e, "model.proposal.investment_sought");
    },

    onLastQuartersRevenueInput(e) {
      this.onCurrencyInput(e, "model.product.last_quarters_revenue");
    },

    onMarketSizeInput(e) {
      let val = e && e.target ? e.target.value : e;
      const onlyNumbers = val.replace(/\D/g, "");
      this.model.product.market_size = onlyNumbers;
      if (e && e.target) {
        const formatted = this.formatCurrency(onlyNumbers);
        this.updateInputWithCursor(e.target, formatted);
      }
    },

    isNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]$/.test(char)) return true;
      else e.preventDefault();
    },

    formatCurrency(value) {
      if (!value && value !== 0) return "";
      const onlyNumbers = value.toString().replace(/\D/g, "");
      if (!onlyNumbers) return "";
      return "R$ " + Number(onlyNumbers).toLocaleString("pt-BR");
    },

    updateInputWithCursor(target, formatted) {
      const start = target.selectionStart;
      const oldLength = target.value.length;
      target.value = formatted;
      const newLength = formatted.length;
      target.setSelectionRange(
        start + (newLength - oldLength),
        start + (newLength - oldLength)
      );
    },

    setNestedProperty(path, value) {
      const keys = path.split(".");
      let obj = this;
      for (let i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
      }
      obj[keys[keys.length - 1]] = value;
    },
    onEquityOfferedInput(e) {
      let val = e && e.target ? e.target.value : e;
      const onlyNumbers = val.replace(/[^\d.,]/g, "");

      const normalizedValue = onlyNumbers.replace(",", ".");

      let numValue = parseFloat(normalizedValue);
      if (numValue > 100) {
        numValue = 100;
      }

      this.model.proposal.equity_offered = numValue || 0;

      if (e && e.target) {
        const formatted = this.formatPercentage(numValue);
        this.updateInputWithCursor(e.target, formatted);
      }
    },
    onPartnerPercentageInput(e, partner) {
      let val = e && e.target ? e.target.value : e;
      const onlyNumbers = val.replace(/[^\d.,]/g, "");

      const normalizedValue = onlyNumbers.replace(",", ".");

      let numValue = parseFloat(normalizedValue);
      if (numValue > 100) {
        numValue = 100;
      }

      partner.percentage = numValue || 0;

      if (e && e.target) {
        const formatted = this.formatPercentage(numValue);
        this.updateInputWithCursor(e.target, formatted);
      }
    },

    formatPercentage(value) {
      if (!value && value !== 0) return "";
      return `${Number(value).toLocaleString("pt-BR")}%`;
    },
    stepKeyFromIndex(index) {
      const keys = [
        "program",
        "registration",
        "business",
        "market",
        "team",
        "proposal",
        "pitch",
      ];
      return keys[index] || null;
    },

    removePitchDeck() {
      this.model.presentation.pitch_deck = null;
      this.fileInputKey++;
    },

    async handleStepAdvance(currentStepIndex, nextTab) {
      if (currentStepIndex === 0) {
        nextTab();
        return;
      }

      const step = currentStepIndex;

      const stepData = this.modelForStep(this.stepKeyFromIndex(step));
      const isValid = this.validateStep(step, stepData);

      if (!isValid) {
        this.$toasted.error("Preencha todos os campos obrigatórios.");
        this.errors.stepError.show = true;
        this.errors.stepError.text =
          "Verifique os campos obrigatórios da etapa.";
        return;
      }

      try {
        if (step === 1) {
          gtmEvent("Iniciou formulário", {
            startup: this.model.startup.name,
            responsavel: this.model.responsible.responsible_name,
          });
          await this.sendPartialStartup(step);
        } else if (step === 2) {
          await this.sendPartialStartupWithBusinessData(step);
        }

        const payload = this.buildStepPayload(step);

        await api.post("/partial/startup-call-subscriptions", payload);
        nextTab();
      } catch (e) {
        this.$toasted.error("Erro ao salvar progresso da etapa.");
        this.errors.stepError.show = true;
        this.errors.stepError.text =
          "Erro ao salvar. Verifique os campos obrigatórios(*).";
      }
    },

    async handleStepBack(currentStepIndex, prevTab) {
      await this.reloadStepData();
      prevTab();
    },

    async sendPartialStartup(step) {
      const payload = {
        registration_step: step,
        name: this.model.startup.name,
        foundation: this.model.startup.foundation || null,
        state: this.model.startup.state,
        city: this.model.startup.city,
      };

      await api.put("/partial/startups/" + this.model.startup_id, payload);
    },

    async sendPartialStartupWithBusinessData(step) {
      const payload = {
        registration_step: step,
        name: this.model.startup.name,
        foundation: this.model.startup.foundation || null,
        state: this.model.startup.state,
        city: this.model.startup.city,
        stage: this.model.product.stage,
        sector: this.model.product.sector.toString(),
        one_sentence_pitch: this.model.product.one_sentence_pitch,
        bussiness_strategy: this.model.startup.bussiness_strategy,
      };

      await api.put("/partial/startups/" + this.model.startup_id, payload);
    },

    buildStepPayload(step) {
      const common = {
        startup_call_id: this.$route.params.id,
      };

      switch (step) {
        case 1: // registration
          return {
            ...common,
            registration_step: 1,
            responsible_name: this.model.responsible.responsible_name,
            responsible_phone: this.model.responsible.responsible_phone,
            responsible_email: this.model.responsible.responsible_email,
            product_more_information: JSON.stringify(
              this.model.startup.product_more_information
            ),
          };
        case 2: // business
          return {
            ...common,
            registration_step: 2,
            product_market_problem: this.model.product.product_market_problem,
            product_bussiness_strategy: this.model.product.bussiness_strategy,
            startup_problem: this.model.product.startup_problem,
            how_can_stars_help: this.model.product.how_can_stars_help,
          };
        case 3: // market
          return {
            ...common,
            registration_step: 3,
            last_quarters_revenue: this.model.product.last_quarters_revenue,
            product_market_cap: this.model.product.market_size,
            active_clients: this.model.product.active_customers,
            product_competitive_advantage:
              this.model.product.product_competitive_advantage,
          };
        case 4: {
          // team
          const socios = this.model.partners
            .map(
              (p) =>
                `Nome: ${p.name}\n` +
                `Dedicação: ${p.dedication}\n` +
                `Percentual da sociedade: ${p.percentage}\n` +
                `Função na startup: ${p.role}\n` +
                `LinkedIn: ${p.linkedin}\n`
            )
            .join("\n");

          return {
            ...common,
            registration_step: 4,
            startup_equity: socios,
            already_participated_batch:
              this.model.startup.already_participated_batch,
          };
        }
        case 5: // proposal
          return {
            ...common,
            registration_step: 5,
            investment_sought: String(this.model.proposal.investment_sought),
            equity_offered: String(this.model.proposal.equity_offered),
          };
        case 6: // pitch
          return {
            ...common,
            registration_step: 6,
            startup_pitch_video_youtube_id: this.getYoutubeVideoId(),
          };
        default:
          return common;
      }
    },

    modelForStep(stepKey) {
      switch (stepKey) {
        case "registration":
          return {
            responsible_name: this.model.responsible.responsible_name,
            responsible_phone: this.model.responsible.responsible_phone,
            responsible_email: this.model.responsible.responsible_email,
            product_more_information:
              typeof this.model.startup.product_more_information === "object"
                ? this.model.startup.product_more_information.link
                : this.model.startup.product_more_information,
          };
        case "business":
          return {
            product_market_problem: this.model.product.product_market_problem,
            product_bussiness_strategy: this.model.product.bussiness_strategy,
            startup_problem: this.model.product.startup_problem,
            how_can_stars_help: this.model.product.how_can_stars_help,
          };
        case "market":
          return {
            last_quarters_revenue: this.model.product.last_quarters_revenue,
            product_market_cap: this.model.product.market_size,
            active_clients: this.model.product.active_customers,
            product_competitive_advantage:
              this.model.product.product_competitive_advantage,
          };
        case "team":
          return {
            startup_equity: this.model.partners,
            already_participated_batch:
              this.model.startup.already_participated_batch,
          };
        case "proposal":
          return {
            investment_sought: this.model.proposal.investment_sought,
            equity_offered: this.model.proposal.equity_offered,
          };
        case "pitch":
          return {
            startup_pitch_video_youtube_id: this.getYoutubeVideoId(),
          };
        default:
          return {};
      }
    },

    async sendStepData(stepName, stepData) {
      try {
        const payload = {
          registration_step: stepName,
          ...stepData,
        };
        await api.post("/partial/startup-call-subscriptions", payload);
      } catch (e) {
        this.$toasted.error("Erro ao salvar progresso da etapa");
      }
    },

    addPartner() {
      this.model.partners.push({
        name: "",
        dedication: "",
        percentage: "",
        role: "",
        linkedin: "",
      });
    },

    async handleSubmitPartner() {
      const campoTexto = this.model.partners
        .map(
          (p) =>
            `Nome: ${p.name}\n` +
            `Dedicação: ${p.dedication}\n` +
            `Percentual da sociedade: ${p.percentage}\n` +
            `Função na startup: ${p.role}\n` +
            `LinkedIn: ${p.linkedin}\n`
        )
        .join("\n");

      const payload = {
        ...this.model,
        partner_field_to_send: campoTexto,
      };

      await this.sendToBackend(payload);
    },
    async handleSubmit() {
      this.modals.disabledSubmit = true;

      let loader = this.$loading.show({
        container: this.$refs.modal_confirmation,
        width: 60,
        height: 60,
        opacity: 0.8,
      });

      try {
        const pitchPayload = this.buildStepPayload(6);
        await api.post("/partial/startup-call-subscriptions", pitchPayload);

        const { data: subscriptions } = await api.get(
          `/startup-call-subscriptions/`
        );

        let subscriptionId = null;
        if (subscriptions && subscriptions.length > 0) {
          subscriptionId = subscriptions[0].id;
        }

        if (!subscriptionId) {
          throw new Error("Subscription ID não encontrado");
        }

        await this.submitDeck(subscriptionId);

        gtmEvent("Concluiu formulário", {
          startup: this.model.startup.name,
          responsavel: this.model.responsible.responsible_name,
        });

        loader.hide();
        this.modals.confirmation = false;
        this.modals.disabledSubmit = false;
      } catch (e) {
        loader.hide();
        this.modals.disabledSubmit = false;
        this.$toasted.error("Ocorreu um erro ao finalizar a inscrição");
      }
    },

    async submitDeck(subscriptionId) {
      const deck = this.model.presentation.pitch_deck;
      if (deck) {
        const data = new FormData();
        data.append("deck", deck, deck.name);
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        try {
          await api.post(
            `/startup-subscriptions/${subscriptionId}/decks`,
            data,
            config
          );
        } catch (e) {
          throw new Error("Erro ao submeter o deck");
        }
      }

      this.$toasted.show("Inscrição na chamada realizada com sucesso", {
        type: "success",
        duration: 5000,
      });
      this.$router.push("/startup/chamadas");
      //Reload to up sidebar with new options when finished inscription
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    },

    onComplete: function () {
      this.modals.confirmation = true;
    },

    validateStep(stepNumber, obj) {
      if (stepNumber === 5) {
        const proposalErrors = this.validateProposalFields();
        if (proposalErrors.length > 0) {
          this.errors.stepError.show = true;
          this.errors.stepError.text = proposalErrors.join("; ");
          return false;
        }
      }

      if (stepNumber === 4) {
        const teamErrors = this.validateTeamFields(obj);
        if (teamErrors.length > 0) {
          this.errors.stepError.show = true;
          this.errors.stepError.text = teamErrors.join("; ");
          return false;
        }
        this.errors.stepError.show = false;
        return true;
      }

      const optionalFields = [
        "product_name",
        "product_sector",
        "product_description",
        "product_development_stage",
        "product_launch_date",
        "product_own_technology",
        "product_more_information",
        "product_market_cap",
        "bussiness_strategy",
        "startup_number_partners",
        "startup_number_employees",
        "startup_partners_description",
        "startup_team_description",
        "already_participated_batch",
      ];
      for (const key in obj) {
        if (
          !optionalFields.includes(key) &&
          (obj[key] === "" || obj[key] === null)
        ) {
          this.errors.stepError.show = true;
          return false;
        }
      }
      this.errors.stepError.show = false;
      return true;
    },
    incubadaChangeHandler(event) {
      if (typeof event === "boolean")
        this.model.startup.startup_is_incubated = event;
    },
    ownTechnologyChangeHandler(event) {
      if (typeof event === "boolean")
        this.model.product.product_own_technology = event;
    },
    getYoutubeVideoId() {
      return getIdFromUrl(this.model.presentation.pitch_video_url);
    },
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    },
    getMbSize(bytes) {
      if (bytes < 1000) return `${bytes} bytes`;
      if (bytes < 1000 * 1000) return `${(bytes / 1000).toFixed(2)} KB`;
      return `${(bytes / 1000 / 1000).toFixed(2)} MB`;
    },
    async loadUserProgress() {
      try {
        const { data } = await api.get(
          `/partial/startup-call-subscriptions?startup_call_id=${this.$route.params.id}`
        );

        if (data && data.length > 0) {
          const subscription = data[0];

          this.loadSubscriptionLastStep(subscription);

          const lastStepCompleted = subscription.last_step_completed;

          let nextTabIndex;
          if (
            lastStepCompleted === null ||
            lastStepCompleted === undefined ||
            lastStepCompleted === 0
          ) {
            nextTabIndex = 0;
          } else {
            nextTabIndex = Math.min(lastStepCompleted + 1, 6);
          }

          this.$nextTick(() => {
            setTimeout(async () => {
              if (this.$refs.wizard && nextTabIndex >= 0 && nextTabIndex < 7) {
                await this.navigateToStep(nextTabIndex);
              }
            }, 100);
          });
        }
      } catch {
        // pass
      }
    },
    updateCurrentStep(prevIndex, nextIndex) {
      if (prevIndex !== 0) {
        this.currentStep = nextIndex + 1;
      }
      this.reloadStepData();
    },

    async navigateToStep(targetIndex) {
      if (!this.$refs.wizard) return;

      const currentIndex = this.$refs.wizard.activeTabIndex;

      if (targetIndex === currentIndex) return;

      if (targetIndex > currentIndex) {
        for (let i = currentIndex; i < targetIndex; i++) {
          await new Promise((resolve) => {
            setTimeout(() => {
              if (this.$refs.wizard) {
                this.$refs.wizard.changeTab(
                  this.$refs.wizard.activeTabIndex,
                  i + 1
                );
              }
              resolve();
            }, 300);
          });
        }
      } else {
        this.$refs.wizard.changeTab(currentIndex, targetIndex);
      }
    },

    async reloadStepData() {
      try {
        const { data } = await api.get(
          `/partial/startup-call-subscriptions?startup_call_id=${this.$route.params.id}`
        );

        if (data && data.length > 0) {
          const subscription = data[0];
          this.loadSubscriptionLastStep(subscription);
        } else {
          const { data: subscriptions } = await api.get(
            `/startup-call-subscriptions/?startup_call_id=${this.$route.params.id}`
          );

          if (subscriptions && subscriptions.length > 0) {
            const subscriptionData = subscriptions[0];
            if (subscriptionData.subscription) {
              this.loadSubscriptionLastStep(subscriptionData.subscription);
            }
          }
        }
      } catch (e) {
        // console.log("Erro ao recarregar dados:", e.message);
      }
    },
    loadSubscriptionLastStep(subscription) {
      if (!subscription) return;

      if (subscription.last_step_completed !== undefined) {
        this.lastStepCompleted = subscription.last_step_completed;
      }
    },

    parsePartnersFromText(partnersText) {
      if (!partnersText) return;

      const partnersData = [];
      const blocks = partnersText.split("\n\n");

      for (const block of blocks) {
        if (block.trim()) {
          const lines = block.split("\n");
          const partner = {
            name: "",
            dedication: "",
            percentage: "",
            role: "",
            linkedin: "",
          };

          lines.forEach((line) => {
            if (line.startsWith("Nome: ")) {
              partner.name = line.replace("Nome: ", "").trim();
            } else if (line.startsWith("Dedicação: ")) {
              partner.dedication = line.replace("Dedicação: ", "").trim();
            } else if (line.startsWith("Percentual da sociedade: ")) {
              const val = line.replace("Percentual da sociedade: ", "").trim();
              partner.percentage = Number(val) || 0;
            } else if (line.startsWith("Função na startup: ")) {
              partner.role = line.replace("Função na startup: ", "").trim();
            } else if (line.startsWith("LinkedIn: ")) {
              partner.linkedin = line.replace("LinkedIn: ", "").trim();
            }
          });

          if (
            partner.name ||
            partner.dedication ||
            partner.percentage ||
            partner.role ||
            partner.linkedin
          ) {
            partnersData.push(partner);
          }
        }
      }

      if (partnersData.length > 0) {
        this.model.partners = partnersData;
      }
    },
    validateProposalFields() {
      const errors = [];

      if (
        !this.model.proposal.investment_sought ||
        this.model.proposal.investment_sought <= 0
      ) {
        errors.push("O valor de investimento deve ser maior que zero");
      }

      if (
        !this.model.proposal.equity_offered ||
        this.model.proposal.equity_offered <= 0
      ) {
        errors.push("O percentual de equity deve ser maior que zero");
      }

      if (this.model.proposal.equity_offered > 100) {
        errors.push("O percentual de equity não pode ser maior que 100%");
      }

      return errors;
    },
    async loadExistingSubscription() {
      try {
        const { data: subscriptionData } = await api.get(
          `partial/startup-call-subscriptions/${this.model.startup_id}`
        );

        if (subscriptionData.foundation) {
          this.model.startup.foundation = subscriptionData.foundation;
        }
        if (subscriptionData.state) {
          this.model.startup.state = subscriptionData.state;
        }
        if (subscriptionData.city) {
          this.model.startup.city = subscriptionData.city;
        }
        if (subscriptionData.stage) {
          this.model.product.stage = subscriptionData.stage;
        }
        if (subscriptionData.sector) {
          this.model.product.sector = subscriptionData.sector
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean);
        }
        if (subscriptionData.one_sentence_pitch) {
          this.model.product.one_sentence_pitch =
            subscriptionData.one_sentence_pitch;
        }
        if (subscriptionData.bussiness_strategy) {
          this.model.startup.bussiness_strategy =
            subscriptionData.bussiness_strategy;
        }

        const subscription = subscriptionData.subscription;

        if (subscription) {
          if (subscription.responsible_name) {
            this.model.responsible.responsible_name =
              subscription.responsible_name;
            this.responsibleFieldsLocked.responsible_name = true;
          }
          if (subscription.responsible_phone) {
            this.model.responsible.responsible_phone =
              subscription.responsible_phone;
            this.responsibleFieldsLocked.responsible_phone = true;
          }
          if (subscription.responsible_email) {
            this.model.responsible.responsible_email =
              subscription.responsible_email;
            this.responsibleFieldsLocked.responsible_email = true;
          }

          if (subscription.product_more_information) {
            try {
              const parsed = JSON.parse(subscription.product_more_information);
              this.model.startup.product_more_information = Array.isArray(
                parsed
              )
                ? parsed[0] || { title: "", link: "" }
                : parsed;
            } catch (e) {
              this.model.startup.product_more_information = {
                title: "site",
                link: subscription.product_more_information,
              };
            }
          } else {
            this.model.startup.product_more_information = {
              title: "",
              link: "",
            };
          }

          if (subscription.product_market_problem) {
            this.model.product.product_market_problem =
              subscription.product_market_problem;
          }
          if (subscription.product_bussiness_strategy) {
            this.model.product.bussiness_strategy =
              subscription.product_bussiness_strategy;
          }
          if (subscription.startup_problem) {
            this.model.product.startup_problem = subscription.startup_problem;
          }
          if (subscription.how_can_stars_help) {
            this.model.product.how_can_stars_help =
              subscription.how_can_stars_help;
          }

          if (subscription.last_quarters_revenue) {
            this.model.product.last_quarters_revenue =
              subscription.last_quarters_revenue;
          }
          if (subscription.product_market_cap) {
            this.model.product.market_size = subscription.product_market_cap;
          }
          if (subscription.active_clients) {
            this.model.product.active_customers = subscription.active_clients;
          }
          if (subscription.product_competitive_advantage) {
            this.model.product.product_competitive_advantage =
              subscription.product_competitive_advantage;
          }

          if (subscription.startup_equity) {
            this.parsePartnersFromText(subscription.startup_equity);
          }
          if (subscription.already_participated_batch) {
            this.model.startup.already_participated_batch =
              subscription.already_participated_batch;
          }

          if (subscription.investment_sought) {
            this.model.proposal.investment_sought =
              Number(subscription.investment_sought) || 0;
          }
          if (subscription.equity_offered) {
            this.model.proposal.equity_offered =
              Number(subscription.equity_offered) || 0;
          }

          if (subscription.startup_pitch_video_youtube_id) {
            this.model.presentation.pitch_video_url = `https://www.youtube.com/watch?v=${subscription.startup_pitch_video_youtube_id}`;
          }
        }
      } catch (e) {
        // console.log(
        //   "Nenhuma inscrição existente encontrada ou erro ao carregar:",
        //   e.message
        // );
      }
    },
    validateTeamFields(obj) {
      const errors = [];

      if (!obj.startup_equity || obj.startup_equity.length === 0) {
        errors.push("É necessário adicionar pelo menos um sócio");
        return errors;
      }

      obj.startup_equity.forEach((partner, index) => {
        const partnerNumber = index + 1;

        if (!partner.name || partner.name.trim() === "") {
          errors.push(`Nome do sócio ${partnerNumber} é obrigatório`);
        }

        if (!partner.dedication || partner.dedication.trim() === "") {
          errors.push(`Dedicação do sócio ${partnerNumber} é obrigatória`);
        }

        if (
          !partner.percentage ||
          partner.percentage.toString().trim() === ""
        ) {
          errors.push(
            `Percentual da sociedade do sócio ${partnerNumber} é obrigatório`
          );
        }

        if (!partner.role || partner.role.trim() === "") {
          errors.push(
            `Função na startup do sócio ${partnerNumber} é obrigatória`
          );
        }

        // if (!partner.linkedin || partner.linkedin.trim() === "") {
        //   errors.push(`LinkedIn do sócio ${partnerNumber} é obrigatório`);
        // }
      });

      return errors;
    },
  },
  computed: {
    getStartupLogoPath() {
      const defaultLogoPath = "/img/pages/default_logo.png";
      const logo = this.startup.logo;
      if (!logo) return defaultLogoPath;
      return logo.url;
    },
    isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.startup_basic_info label {
  font-weight: bold;
}

.card-profile-image-custom img {
  -webkit-transform: translate(-50%, -30%);
  transform: translate(-50%, -30%);
  position: absolute;
  left: 50%;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
}
.card-profile-image-custom img:hover {
  -webkit-transform: translate(-50%, -33%);
  transform: translate(-50%, -33%);
}

.card-profile-image img {
  display: block;
  width: 100px;
  height: 100px;
  border-radius: 10%;
}

.orange-button {
  background-color: #ff4200 !important;
  border-color: #ff4200 !important;
  color: white !important;
}

.orange-button-pitch {
  color: white !important;
}

.img-title {
  max-width: 400px;
}
.finish-button {
  background-color: #43a047 !important;
  border-color: #43a047 !important;
}
.finish-button:hover,
.finish-button:focus,
.finish-button:active {
  background-color: #1e8623 !important;
  border-color: #1e8623 !important;
}

.vue-form-wizard .wizard-btn {
  padding: 9px 12px;
}

.input-unit-box {
  position: relative;
}

.value-box {
  background: white;
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
}

.icon {
  height: 30px;
  width: 30px;
  color: #ff4200;
  filter: brightness(0) saturate(100%) sepia(1) hue-rotate(-30deg);
}

.value-text {
  color: #ff4200;
  font-weight: 700;
  font-size: 1.2rem;
}

.value-label {
  color: #a0a0a0;
  font-size: 0.85rem;
  margin-top: 4px;
  text-transform: uppercase;
}

.input-unit {
  display: block;
  border: 1px solid #d7d6d6;
  background: #fff;
  padding: 10px 30px 10px 10px;
}
.orange-title {
  font-size: 1rem;
  font-weight: 400;
  color: #ff4200;
  margin-bottom: 1rem;
}
.section-divider {
  margin-top: 3rem;
  padding-top: 2rem;
}

.unit {
  position: absolute;
  display: block;
  right: 10px;
  top: 10px;
  z-index: 9;
  color: #444444;
}
</style>
